module.exports = __webpack_public_path__ + "static/media/hotel-16.152d0cf2.jpg";